import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { CheckCircleIcon } from 'lucide-react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const megaPackUrl = 'https://checkout.guiadigital360.online/cart/43889650401349:1';
  const aceleradorUrl = 'https://checkout.guiadigital360.online/cart/44773397397573:1';
  return <section id="compra" className="py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-251">
      <div className="max-w-5xl mx-auto" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-5xl font-black text-brand-dark mb-4" data-id="element-254">
            Elegí tu Manual:
          </h2>
          <p className="text-2xl font-bold text-brand-rust" data-id="element-255">
            Las dos opciones incluyen los bonos de regalo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-stretch mb-16 max-w-4xl mx-auto" data-id="element-256">
          {/* Card 1: Mega Pack */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full" data-id="element-257">
            <div className="text-5xl mb-4" data-id="element-258">📘</div>
            <h3 className="text-2xl font-black text-brand-dark mb-4" data-id="element-259">
              MEGA PACK COMPLETO
            </h3>

            <ul className="space-y-3 mb-8" data-id="element-260">
              {['Los 5 Tomos Maestros completos', 'Bono 1 — Pack Publicación que Vende', 'Bono 2 — Kit Fotos Pro con Celular', 'Bono 3 — Checklist Taller Seguro', '🏋️ Bono Gym — Planos de Estructuras para Gimnasios'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-261">
                  <CheckCircleIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-262" />
                  <span className="text-gray-700 font-medium" data-id="element-263">{item}</span>
                </li>)}
            </ul>

            <div className="mt-auto" data-id="element-264">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-265">
                $49.900
              </div>
              <div className="text-4xl font-black text-brand-amber mb-6" data-id="element-266">
                $19.990 ARS
              </div>
              <CTAButton text="→ QUIERO EL MEGA PACK" href={megaPackUrl} isLink={true} className="text-lg py-3" data-id="element-267" />

              {/* Guarantee Badge */}
              <div className="flex justify-center mt-6" data-id="element-268">
                
              </div>
            </div>
          </div>

          {/* Card 2: Con Acelerador (Highlighted) */}
          <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-brand-amber relative transform md:scale-105 z-10 flex flex-col h-full" data-id="element-269">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-amber text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-270">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-271">⚡</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-272">
              MEGA PACK
              <br data-id="element-273" />+ ACELERADOR 24HS
            </h3>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-4" data-id="element-274">
              TU PRIMERA VENTA EN 30 DÍAS
            </div>

            <ul className="space-y-3 mb-6" data-id="element-275">
              {['Todo el Mega Pack Completo', 'Mapa exacto de 30 días para tu primera venta', 'Calculadora de Precios lista para usar', 'Plan de Acción Diario día a día', 'Guiones para negociar en el corralón', '+700 planos adicionales listos para fabricar'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-276">
                  <CheckCircleIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-277" />
                  <span className="text-gray-700 font-medium" data-id="element-278">{item}</span>
                </li>)}
            </ul>

            <div className="mt-auto text-center" data-id="element-279">
              <div className="text-gray-400 text-2xl line-through font-bold mb-1" data-id="element-280">
                $49.900
              </div>
              <div className="text-5xl font-black text-brand-amber mb-6" data-id="element-281">
                $24.990 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL ACELERADOR" href={aceleradorUrl} isLink={true} className="text-xl py-4" data-id="element-282" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base text-gray-600 font-bold bg-white py-6 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-283">
          <span className="flex items-center gap-2" data-id="element-284">
            <LockIcon className="w-6 h-6 text-gray-500" data-id="element-285" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-286">
            <ZapIcon className="w-6 h-6 text-brand-forge" data-id="element-287" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-288">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-289" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-290">
            <CreditCardIcon className="w-6 h-6 text-brand-steel" data-id="element-291" /> Mercado Pago
            · Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}